/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const intakeFormSlice = createSlice({
  name: 'intakeForm',
  initialState: {
    data: {},
    hasConsent: false,
  } as any,
  reducers: {
    setIntakeFormData: (
      state,
      { payload }: PayloadAction<{ id: string, value: string }>,
    ) => { state.data[payload.id] = payload.value; },
    setIntakeFormConsent: (
      state,
      { payload: { hasConsent } }: PayloadAction<{ hasConsent: boolean }>,
    ) => {
      state.hasConsent = hasConsent
    },
    clearIntakeFormData: () => ({}),
  },
});

export const {
  setIntakeFormData,
  setIntakeFormConsent,
  clearIntakeFormData,
} = intakeFormSlice.actions;

export default intakeFormSlice.reducer;
export const selectIntakeForm = (state: any) => state.intakeForm;
